import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchSessionMoveTypes = async ({ sessionId, mediaType }) => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${__API_URL__}/api/photos/sessions/${sessionId}/move-types/`, {
    params: { media_type: mediaType },
    headers: { Authorization: `Token ${token}` },
  });
  return res.data.types;
};

const useGetSessionMoveTypes = ({ sessionId, mediaType, enabled = true }) => {
  return useQuery({
    queryKey: ["session-move-types", sessionId, mediaType],
    queryFn: () => fetchSessionMoveTypes({ sessionId, mediaType }),
    enabled: enabled && Boolean(sessionId) && Boolean(mediaType),
  });
};

export default useGetSessionMoveTypes;
